import { gql, useQuery, QueryHookOptions } from '@apollo/client';

import { FontFamiliesQuery } from 'client/graphql/types/operations';

export type { FontFamiliesQuery };

const FONT_FAMILIES_QUERY = gql`
  query FontFamiliesQuery {
    fontFamilies {
      id
      name
      slug
      position
      conceptFont
      variableWeightMin
      variableWeightMax
      variableLineHeight
      variableMarginBottom
      variableFontUrl
      variableFontFallbackUrl
      textColor
      homePageTextColor
      widthsCount
      facesCount
      variableFontsCount
    }
  }
`;

const useFontFamiliesQuery = (
  options: QueryHookOptions<FontFamiliesQuery> = {},
) => {
  return useQuery<FontFamiliesQuery>(FONT_FAMILIES_QUERY, options);
};

export default useFontFamiliesQuery;
